import { useEffect } from 'react';
import { FieldValues, UseFormTrigger } from 'react-hook-form';

interface UseTriggerValidationOnDeselection<T extends FieldValues> {
    trigger: UseFormTrigger<T>;
    selected: boolean;
}
const useTriggerValidationOnDeselection = <T extends FieldValues>({
    trigger,
    selected,
}: UseTriggerValidationOnDeselection<T>) => {
    useEffect(() => {
        if (!selected) {
            trigger();
        }
    }, [selected, trigger]);
};

export { useTriggerValidationOnDeselection };
